import React from 'react';
import styled from 'styled-components';

type MobileTopBarSelectorsProps = {
  teamDropdown?: React.ReactNode;
  periodDropdown: React.ReactNode;
};

const MobileTopBarSelectors: React.FC<MobileTopBarSelectorsProps> = ({ teamDropdown, periodDropdown }) => (
  <SelectorsRow>
    {teamDropdown ? (
      <TeamColumn>
        <SelectorBox>{teamDropdown}</SelectorBox>
      </TeamColumn>
    ) : null}
    <PeriodColumn>
      <SelectorBox>{periodDropdown}</SelectorBox>
    </PeriodColumn>
  </SelectorsRow>
);

export default MobileTopBarSelectors;

const SelectorsRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;
`;

const TeamColumn = styled.div`
  flex: 2 0 0;
  min-width: 0;
`;

const PeriodColumn = styled.div`
  flex: 1 0 0;
  min-width: 0;
`;

const SelectorBox = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: visible;
  position: relative;
  min-width: 0;
  width: 100%;

  .mobile-control-dropdown.ui.dropdown {
    width: 100% !important;
    font-family: 'Poppins', sans-serif !important;
    font-size: 18px !important;
    font-weight: 550 !important;
    min-height: 40px !important;
    padding: 0 10px !important;
    border-radius: 12px !important;
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    display: flex !important;
    align-items: center !important;
  }

  .mobile-control-dropdown.ui.dropdown .text,
  .mobile-control-dropdown.ui.dropdown.selection .text,
  .mobile-control-dropdown.ui.dropdown.selection.active .text,
  .mobile-control-dropdown.ui.dropdown.selection:hover .text,
  .mobile-control-dropdown.ui.dropdown.selection:focus-within .text {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 550 !important;
    font-size: 18px !important;
    line-height: 24px !important;
    padding: 8px 0 !important;
    min-height: 40px !important;
    display: inline-flex !important;
    align-items: center !important;
  }

  .mobile-control-dropdown.ui.dropdown.selection.active,
  .mobile-control-dropdown.ui.dropdown.selection.active:hover,
  .mobile-control-dropdown.ui.dropdown.selection:hover,
  .mobile-control-dropdown.ui.dropdown.selection:focus-within,
  .mobile-control-dropdown.ui.dropdown.active.dropdown {
    border-color: transparent !important;
    box-shadow: none !important;
  }

  .mobile-control-dropdown.ui.dropdown .menu .item {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 550 !important;
    font-size: 18px !important;
    line-height: 20px !important;
  }

  .mobile-control-dropdown.ui.dropdown .dropdown.icon,
  .mobile-control-dropdown.ui.dropdown i.dropdown.icon {
    display: none !important;
  }

  .mobile-control-dropdown.ui.dropdown .menu {
    border: 1px solid #e5e7eb !important;
    border-radius: 12px !important;
    box-shadow: none !important;
    z-index: 115 !important;
    background: #ffffff !important;
    max-height: calc(100vh - 160px) !important;
    overflow-y: auto !important;
  }
`;
